// src/pages/Collection.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LottieFromS3 from "./LottieFromS3";
import { supabase } from "../supabaseClient";
import "../styles/Collection.css";

interface OnionCard {
  key: string;
  name: string;
  description: string;
  lottiePath: string;
  bg: string;
}

const S3_BASE =
"https://onion-project-assets.s3.ap-northeast-2.amazonaws.com";

const ALL: OnionCard[] = [
  {
    key: "onion_stage1",
    name: "아기 양파",
    description: "모험의 시작!",
    lottiePath: `${S3_BASE}/assets/lottie/onion1.json`,
    bg: "#E8F5E9",
  },
  {
    key: "onion_stage2",
    name: "어린이 양파",
    description: "무럭무럭 자라는 중",
    lottiePath: `${S3_BASE}/assets/lottie/onion2.json`,
    bg: "#E3F2FD",
  },
  {
    key: "onion_stage3",
    name: "청소년 양파",
    description: "이제 제법 듬직해요",
    lottiePath: `${S3_BASE}/assets/lottie/onion3.json`,
    bg: "#FFF3E0",
  },
  {
    key: "onion4_clean",
    name: "깔끔 양파",
    description: "반짝반짝 빛이 나요",
    lottiePath: `${S3_BASE}/assets/lottie/onion4_clean.json`,
    bg: "#F3E5F5",
  },
  {
    key: "onion4_half",
    name: "반쪽 양파",
    description: "속이 궁금해?",
    lottiePath: `${S3_BASE}/assets/lottie/onion4_half.json`,
    bg: "#FFEBEE",
  },
  {
    key: "onion4_mandu",
    name: "만두 양파",
    description: "맛있는 변신!",
    lottiePath: `${S3_BASE}/assets/lottie/onion4_mandu.json`,
    bg: "#EFEBE9",
  },
  {
    key: "onion4_study",
    name: "공부 양파",
    description: "열심히 공부해서 성공할 거야",
    lottiePath: `${S3_BASE}/assets/lottie/onion4_study.json`,
    bg: "#E0F7FA",
  },
  {
    key: "onion4_white",
    name: "순백 양파",
    description: "가장 순수한 모습",
    lottiePath: `${S3_BASE}/assets/lottie/onion4_white.json`,
    bg: "#FBE9E7",
  },
];

export default function Collection() {
  const navigate = useNavigate();
  const [unlocked, setUnlocked] = useState<string[]>([]);

  useEffect(() => {
    const uid = localStorage.getItem("user_id");
    if (!uid) return;

    supabase
      .from("collection")
      .select("onion_type")
      .eq("user_id", uid)
      .then(({ data }) => {
        setUnlocked(data?.map((d) => d.onion_type) ?? []);
      });
  }, []);

  return (
    <div className="collection-page">
      <div className="collection-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← 뒤로 가기
        </button>

        <div className="content-box">
          <div className="header-section">
            <h1>나의 양파 컬렉션</h1>
            <p>성장 일기를 쓰며 모은 다양한 양파 친구들을 만나보세요!</p>
          </div>

          <div className="card-grid">
            {ALL.map((item) => {
              const isUnlocked =
                item.key === "onion_stage1" ||
                unlocked.includes(item.key);

              return (
                <div
                  key={item.key}
                  className={`character-card ${
                    isUnlocked ? "unlocked" : "locked"
                  }`}
                >
                  {!isUnlocked && <div className="lock-icon">🔒</div>}

                  <div
                    className="image-box"
                    style={{ backgroundColor: isUnlocked ? item.bg : "#eee" }}
                  >
                    {isUnlocked ? (
                      <div className="lottie-wrapper">
                        <LottieFromS3 url={item.lottiePath} />
                      </div>
                    ) : (
                      <span className="locked-mark">?</span>
                    )}
                  </div>

                  <div className="card-info">
                    <h3>{item.name}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
